// extracted by mini-css-extract-plugin
export default {"button":"button-close_button__lUJW+","icon":"button-close_icon__xBK7m"};